<template>
  <section v-if="isOpen">
    <div class="content" v-on-click-outside="close">
      <h2>Info</h2>

      <button @click="close" class="close">❌</button>

      <p>
        Aasta läbi, eriti aga praegusel teede lagunemise ajal saab Postimees
        ridamisi vihjeid auklikest või muidu kehvadest teedest. Ajalehe Sakala
        eestvedamisel valminud kaardirakendus võimaldab ohtlikud kohad kiiresti
        ja lihtsalt avalikuks vaatamiseks üles märkida.
      </p>

      <p>
        Kui GPS on sisse lülitatud, näitab kaardirakendus automaatselt kasutaja
        asukohta ning tuleb vaid vajutada nupule "Märgi". Saab valida, kas tegu
        on löökaugu, aukliku tee, läbimatu tee või teel oleva takistusega.
        Võimalik on lisada foto ja kirjeldus.
      </p>

      <p>
        Automaatse positsioneerimise saab ka välja lülitada ja määrata asukoha
        käsitsi kaarti liigutades. Kõik ülejäänu toimib samamoodi.
      </p>

      <p>
        Sirvimise vaates saavad lugejad teiste kasutajate sisestatud infot
        vaadata ja kordatehtud koha parandatuks märkida.
      </p>
    </div>
  </section>
</template>

<style scoped>
section {
  position: absolute;
  z-index: 99999;

  width: 100%;
  height: 100%;

  background-color: rgba(26 26 26 / 0.16);
  backdrop-filter: grayscale(1) blur(8px);

  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  box-sizing: border-box;
  padding: 1em;

  border-radius: 6px;
  box-shadow: 0 1px #cdd4db, 0 -1px #e3e9ed;

  background-color: var(--lightest);

  width: 96%;
  max-width: 555px;

  margin-top: 5em;

  position: relative;
}

h2 {
  font-size: 1.75em;
  margin: 0;
}

p {
  font-weight: 300;
  line-height: 1.25;
}

.close {
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.33em;

  filter: grayscale(0.5);
}

.close:hover {
  filter: grayscale(0.1);
}
</style>

<script setup>
import { ref, toRef, computed, onMounted, onUnmounted } from "vue";

import { vOnClickOutside } from "@vueuse/components";

const emit = defineEmits(["close"]);

function close() {
  emit("close");
}

const props = defineProps({
  isOpen: Boolean,
});
</script>
